// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"137":"cf8a7de1","170":"d7413e9c","672":"ead4c48a"}[chunkId] + ".css";
};